export const formatPercents = (value: number) => {
  return `${Math.round(value * 100) / 100}%`;
};
